var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import previewMetadata from '@cdo/static/dance/preview-metadata.json';
// Common utils shared between legacy and Lab2 Dance
function computeCharactersReferenced(studentCode) {
    // Process studentCode to determine which characters are referenced and create
    // charactersReferencedSet with the results:
    var charactersReferencedSet = new Set();
    var charactersRegExp = new RegExp(/^.*make(Anonymous|New)DanceSprite(?:Group)?\([^"]*"([^"]*)[^\r\n]*/, 'gm');
    var match;
    while ((match = charactersRegExp.exec(studentCode))) {
        var characterName = match[2];
        charactersReferencedSet.add(characterName);
    }
    // Special parsing for the JSON parameter to ai().
    var aiCharactersRegExp = new RegExp(/ai\(([^\)]*)/, 'gm');
    while ((match = aiCharactersRegExp.exec(studentCode))) {
        if (match[1] === 'undefined') {
            continue;
        }
        try {
            var params = JSON.parse(match[1]);
            if (params.dancers && params.dancers.type) {
                var characterName = params.dancers.type.toUpperCase();
                charactersReferencedSet.add(characterName);
            }
        }
        catch (e) {
            console.log('Invalid JSON for ai() block.');
        }
    }
    return Array.from(charactersReferencedSet);
}
// Generate the validation callback from stringified validation code.
// TODO: We're allowing the return type to be a generic 'Function' since the Dance Party
// repo currently doesn't export types. If/when types are available, we can narrow the
// return type.
// eslint-disable-next-line @typescript-eslint/ban-types
function getValidationCallback(validationCode) {
    return new Function('World', 'nativeAPI', 'sprites', 'events', validationCode);
}
/**
 * Returns fixed song metadata for the Dance Party live preview,
 * updated with the current song's artist and title.
 */
function getSongMetadataForPreview(songMetadata) {
    return __assign(__assign({}, previewMetadata), { title: songMetadata.title, artist: songMetadata.artist });
}
// Need to use default exports for stubbing these functions in tests
export default {
    computeCharactersReferenced: computeCharactersReferenced,
    getValidationCallback: getValidationCallback,
    getSongMetadataForPreview: getSongMetadataForPreview,
};
